import CardHolderDisclaimer from './CardHolderDisclaimer';

export default CardHolderDisclaimer;
